import { isUserSubscribedToChannel } from "./subscriptionUtils";

// Ads flow enable or disable check
export const isAdsEnabled = (subscriptions, addons) => {
  let isActive = false;
  subscriptions.forEach(name => {
    const activeSubName = isUserSubscribedToChannel(addons, name);
    if (activeSubName) {
      isActive = true;
      return;
    }
  });
  return isActive;
};

// Show Sponsor Bugs based on user active subscriptions
export const showSponsorBugs = (addons, config) => {
  const platformData = config?.samsungtv;
  if (platformData && platformData?.sponsorship_premium_subs) {
    const subsNameArr = platformData?.sponsorship_premium_subs.split(",");
    const showSponsorBugs = isAdsEnabled(subsNameArr, addons);
    return showSponsorBugs;
  } else if (config?.sponsorship_premium_subs) {
    const subsNameArr = config?.sponsorship_premium_subs.split(",");
    const showSponsorBugs = isAdsEnabled(subsNameArr, addons);
    return showSponsorBugs;
  }
};

// Show Pause Ads based on user active subscriptions
export const showPauseAds = (addons, config) => {
  const platformData = config?.samsungtv;
  if (platformData && platformData?.pause_ads_premium_subs) {
    const subsNameArr = platformData?.pause_ads_premium_subs.split(",");
    const showPauseAds = isAdsEnabled(subsNameArr, addons);
    return showPauseAds;
  } else if (config?.pause_ads_premium_subs) {
    const subsNameArr = config?.pause_ads_premium_subs.split(",");
    const showPauseAds = isAdsEnabled(subsNameArr, addons);
    return showPauseAds;
  }
};
